import "@/components/skeleton/dashboard-skeleton.css";

/** A single shimmer bar (mirrors the shared skeleton primitive). */
function Bar({
  w,
  h = 12,
  r = 6,
  style,
}: {
  w: number | string;
  h?: number;
  r?: number;
  style?: React.CSSProperties;
}) {
  return (
    <span
      className="sk"
      style={{ width: w, height: h, borderRadius: r, ...style }}
    />
  );
}

/**
 * Dedicated loader for the "by Discipline" card — kept separate from
 * `DashboardMetricsSkeleton` so this section loads and shimmers on its own,
 * independent of the KPI / table skeletons. Doubles as the Suspense fallback
 * while the (lazy) card chunk downloads.
 *
 * Laid out as the card's DEFAULT mode (Snapshot): a header with its toggle, six
 * bar rows on the card's own `46px 1fr 60px` grid, then the benchmark footnote —
 * so the real card swaps in without a layout jump.
 */
export default function DisciplineBreakdownCardSkeleton() {
  return (
    <section
      className="pp-card"
      style={{ marginTop: 16, marginBottom: 16 }}
      aria-hidden="true"
    >
      <div className="dsc-head">
        <Bar w={220} h={13} />
        <Bar w={148} h={30} r={9} />
      </div>
      <div className="dsc-bars">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="dsc-row">
            <Bar w={34} h={11} />
            <Bar w="100%" h={23} r={5} />
            <Bar w={44} h={11} style={{ justifySelf: "end" }} />
          </div>
        ))}
      </div>
      <Bar w={280} h={11} style={{ marginTop: 14 }} />
    </section>
  );
}
